import React, {Component} from 'react';
import SelectButton from '../../../components/icon/SelectButton';

class AthOnboardingProductsBuild extends Component {
    constructor(props){
        super(props);

        this.handleOnClick = this.handleOnClick.bind(this);
        this.itemsSelected = 0;

        this.state = {
            customSectionSelected: !this.props.notSelected,
            washSelected:false,
            conditionSelected:false,
            drySelected:false,
            refreshSelected:false,
            styleSelected:false
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.notSelected !== this.props.notSelected) {
            this.setState({
                customSectionSelected: prevProps.notSelected, 
                washSelected:false,
                conditionSelected:false,
                drySelected:false,
                refreshSelected:false,
                styleSelected:false
            });
        }
    }

    handleOnClick(e, target) {
        let selected = this.state[target];
        this.setState({ [target]: !this.state[target] });
        if (target === "washSelected") {

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ cats: "wash", value: "Wash"});
            } else {
                this.itemsSelected--;
                this.props.removeItem({ cats: "wash", value: "Wash" });
            }
        }
        if (target === "conditionSelected") {

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ cats: "condition", value: "Condition" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ cats: "condition", value: "Condition" });
            }
        }

        if (target === "drySelected") {

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ cats: "dry", value: "Dry" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ cats: "dry", value: "Dry" });
            }
        }

        if (target === "refreshSelected") {

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ cats: "refresh", value: "Refresh" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ cats: "refresh", value: "Refresh" });
            }
        }

        if (target === "styleSelected") {


            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ cats: "style", value: "Style" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ cats: "style", value: "Style" });
            }
        }

        
    }

    render() {
        const productArray = [
            { cats: "wash", value: "Wash", target: "washSelected" },
            { cats: "condition", value: "Condition", target: "conditionSelected" },
            { cats: "dry", value: "Dry", target: "drySelected" },
            { cats: "style", value: "Style", target: "styleSelected" },
            { cats: "refresh", value: "Refresh", target: "refreshSelected" }
        ];

        
        
        const productButtons = productArray.map(product => {
            
            return(
                 <div key={ product.index } className="option" onClick={(e) => this.handleOnClick(e, product.target)}>
                    <SelectButton name={ product.value } selectable={ true }
                        selected={ false } 
                        id={ "productButton-" + product.index }
                        customSelected={ this.state.customSectionSelected  }
                    />
                </div>
            );
        });

        return (
            <div className="custom-routine-products">
                { productButtons }
            </div>
        );
    }
    
}

export default AthOnboardingProductsBuild;



// WEBPACK FOOTER //
// ./src/ath/components/onboarding/AthOnboardingProductsBuild.js